/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { TIDUser } from './types/TIDUser';
import { TIDAuthState } from './state';

/**
 * Actions available to manage the state of the TID Provider
 */
type Action =
  | { type: 'INIT'; user?: TIDUser }
  | { type: 'LOGOUT' }
  | { type: 'GET_ACCESS_TOKEN_COMPLETE'; user?: TIDUser }
  | { type: 'HANDLE_CALLBACK_COMPLETE'; user?: TIDUser }
  | { type: 'ERROR'; error: Error };

/**
 * This function manage the state and logic of the TID Provider
 * @param {TIDAuthState} state - Current state of the application
 * @param {Action} action - Action to execute
 * @return {TIDAuthState} Empty promise
 */
export const reducer = (state: TIDAuthState, action: Action): TIDAuthState => {
  switch (action.type) {
    case 'INIT':
      return {
        ...state,
        isLoading: false,
        isAuthenticated: action.user != null,
        user: action.user,
        error: undefined,
      };
    case 'HANDLE_CALLBACK_COMPLETE':
    case 'GET_ACCESS_TOKEN_COMPLETE':
      return {
        ...state,
        isLoading: false,
        isAuthenticated: action.user != null,
        user: action.user,
        error: undefined,
      };
    case 'LOGOUT':
      return {
        ...state,
        isAuthenticated: false,
        user: undefined,
      };
    case 'ERROR':
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
  }
};
